// Color scheme definitions
export const colorSchemes = {
	blue: {
		light: {
			primary: "bg-blue-600",
			primaryForeground: "text-white",
			primaryHover: "hover:bg-blue-700",
			primaryRing: "ring-blue-600",
			chip: "bg-blue-100 text-blue-800",
			chipDark: "bg-blue-900/30 text-blue-400 border-blue-800/50",
		},
		dark: {
			primary: "bg-blue-500",
			primaryForeground: "text-blue-950",
			primaryHover: "hover:bg-blue-400",
			primaryRing: "ring-blue-500",
			chip: "bg-blue-900/30 text-blue-400 border-blue-800/50",
			chipDark: "bg-blue-900/30 text-blue-400 border-blue-800/50",
		},
	},
	zinc: {
		light: {
			primary: "bg-zinc-900",
			primaryForeground: "text-white",
			primaryHover: "hover:bg-zinc-800",
			primaryRing: "ring-zinc-900",
			chip: "bg-zinc-100 text-zinc-800",
			chipDark: "bg-zinc-800 text-zinc-300 border-zinc-700",
		},
		dark: {
			primary: "bg-zinc-50",
			primaryForeground: "text-zinc-900",
			primaryHover: "hover:bg-zinc-100",
			primaryRing: "ring-zinc-50",
			chip: "bg-zinc-800 text-zinc-300 border-zinc-700",
			chipDark: "bg-zinc-800 text-zinc-300 border-zinc-700",
		},
	},
};

// Shadcn-style color theme object
export const themeColors = {
	light: {
		background: "bg-white",
		foreground: "text-zinc-900",
		muted: "bg-zinc-50",
		mutedForeground: "text-zinc-500",
		mutedBackground: "bg-gray-50",
		border: "border-zinc-200",
		input: "border-zinc-200",
		card: "bg-white",
		cardForeground: "text-zinc-900",
		primary: "bg-zinc-900",
		primaryForeground: "text-white",
		secondary: "bg-zinc-100",
		secondaryForeground: "text-zinc-700",
		accent: "bg-zinc-100",
		accentForeground: "text-zinc-900",
		hover: "hover:bg-zinc-50",
		hoverPrimary: "hover:bg-zinc-800",
		hoverSecondary: "hover:bg-zinc-100",
		ring: "ring-zinc-900",
		shadow: "shadow-sm",
		textMuted: "text-zinc-400",
		textSecondary: "text-zinc-700",
		textTertiary: "text-zinc-500",
	},
	dark: {
		background: "bg-zinc-900",
		foreground: "text-zinc-50",
		muted: "bg-zinc-900",
		mutedForeground: "text-zinc-400",
		mutedBackground: "bg-zinc-950",
		border: "border-zinc-800",
		input: "border-zinc-800",
		card: "bg-zinc-900",
		cardForeground: "text-zinc-50",
		primary: "bg-zinc-50",
		primaryForeground: "text-zinc-900",
		secondary: "bg-zinc-900",
		secondaryForeground: "text-zinc-200",
		accent: "bg-zinc-800",
		accentForeground: "text-zinc-50",
		hover: "hover:bg-zinc-900",
		hoverPrimary: "hover:bg-zinc-100",
		hoverSecondary: "hover:bg-zinc-800",
		ring: "ring-zinc-50",
		shadow: "shadow-lg",
		textMuted: "text-zinc-500",
		textSecondary: "text-zinc-300",
		textTertiary: "text-zinc-400",
	},
};

// Helper function to get focus ring class based on color scheme
export const getFocusRingClass = (colorScheme) => {
	const ringClasses = {
		blue: "focus:ring-blue-600 dark:focus:ring-blue-500",
		zinc: "focus:ring-zinc-900 dark:focus:ring-zinc-50",
	};
	return ringClasses[colorScheme] || ringClasses.zinc;
};
